<template>
  <modal
    v-if="modal"
    :pivot-y="0.1"
    :adaptive="true"
    :scrollable="true"
    :name="modal"
    height="auto"
    width="400"
  >
    <div class="p-3">
      <modal-title>
        Please confirm
      </modal-title>
      <h2 class="mb-3">
        <slot>Are you sure you want to delete {{ name }}?</slot>
      </h2>

      <div class="d-flex">
        <button
          type="button"
          class="ml-auto btn btn-outline-primary"
          style="min-width: 100px"
          @click="$modal.hide(modal)"
        >
          Cancel
        </button>
        <button
          type="button"
          @click="confirmed"
          class="btn btn-primary ml-2"
          style="min-width: 100px"
        >
          Confirm
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import ModalTitle from './ModalTitle'

export default {
  components: {
    ModalTitle,
  },
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    modal: {
      required: false,
      type: String,
      default: 'confirm-delete',
    },
  },
  methods: {
    confirmed () {
      this.$emit('confirmed')
      this.$modal.hide(this.modal)
    },
  },
}

</script>
